import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=3737f2da&scoped=true&"
var script = {}
import style0 from "./dashboard.scss?vue&type=style&index=0&id=3737f2da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3737f2da",
  null
  
)

export default component.exports